// extracted by mini-css-extract-plugin
export default {"option":"tokenDropdown_option__BzuRC"};